import React, { memo } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { Colors } from 'context';
import fontService, { FontWeight } from 'services/FontService';
import { desktop, tablet } from 'services/ui';

export const LessonStudentResources = memo(() => {
  const { t } = useTranslation();

  return (
    <Container>
      <Title>{t('lesson.resources.title')}</Title>
      <Description>{t('lesson.resources.description')}</Description>

      <CalculatorSection>
        <CalculatorTitle>{t('lesson.resources.calculator.title')}</CalculatorTitle>
        <CalculatorDescription>
          {t('lesson.resources.calculator.description')}
        </CalculatorDescription>
        <IframeContainer>
          <StyledIframe
            src="https://dilan2.github.io/lit_docker_quiz_test/docker_quiz.html"
            title={t('lesson.resources.calculator.title')}
            frameBorder="0"
            allowFullScreen
          />
        </IframeContainer>
      </CalculatorSection>
    </Container>
  );
});

const Container = styled.div`
  width: 100%;
  padding: 20px 0;
`;

const Title = styled.h2`
  margin: 0 0 16px 0;
  color: ${Colors.black};
  ${fontService.getFont({ size: 24, lineHeight: 133, weight: FontWeight.bold })}

  ${tablet} {
    ${fontService.getFont({ size: 28, lineHeight: 143, weight: FontWeight.bold })}
  }

  ${desktop} {
    ${fontService.getFont({ size: 32, lineHeight: 138, weight: FontWeight.bold })}
  }
`;

const Description = styled.p`
  margin: 0 0 32px 0;
  color: ${Colors.gray_dark};
  ${fontService.getFont({ size: 16, lineHeight: 150, weight: FontWeight.regular })}

  ${tablet} {
    ${fontService.getFont({ size: 18, lineHeight: 155, weight: FontWeight.regular })}
  }
`;

const CalculatorSection = styled.section`
  margin-top: 32px;
  padding: 24px;
  background-color: ${Colors.bg_gray};
  border-radius: 12px;
  border: 1px solid ${Colors.system_gray};

  ${tablet} {
    padding: 32px;
    border-radius: 16px;
  }
`;

const CalculatorTitle = styled.h3`
  margin: 0 0 12px 0;
  color: ${Colors.black};
  ${fontService.getFont({ size: 20, lineHeight: 140, weight: FontWeight.bold })}

  ${tablet} {
    ${fontService.getFont({ size: 22, lineHeight: 145, weight: FontWeight.bold })}
  }
`;

const CalculatorDescription = styled.p`
  margin: 0 0 20px 0;
  color: ${Colors.gray_dark};
  ${fontService.getFont({ size: 14, lineHeight: 150, weight: FontWeight.regular })}

  ${tablet} {
    ${fontService.getFont({ size: 16, lineHeight: 150, weight: FontWeight.regular })}
  }
`;

const IframeContainer = styled.div`
  width: 100%;
  height: 600px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

  ${tablet} {
    height: 700px;
    border-radius: 12px;
  }

  ${desktop} {
    height: 800px;
  }
`;

const StyledIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
`;
